const SvgError = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667m1.333 20h-2.667V20h2.667zm0-5.334h-2.667v-8h2.667z" />
  </svg>;
export default SvgError;